import i18next from 'i18next';
import common_en from './translations/en/common.json';
import mvp_en from './translations/en/mvp.json';
import dentaquest_en from './translations/en/dentaquest.json';
import ahc_en from './translations/en/ahc.json';
import ahcadmin_en from './translations/en/ahcadmin.json';
import transport_en from './translations/en/transport.json';
import { mergeTranslationResources } from './i18nUtils';
import type { TranslationResource } from './i18nUtils';

const PUBLIC_COMMON_TRANSLATIONS_PATH = '/common.json';

const isRecord = (value: unknown): value is TranslationResource =>
  Object.prototype.toString.call(value) === '[object Object]';

const loadPublicCommonTranslations = async (): Promise<TranslationResource> => {
  try {
    const response = await fetch(PUBLIC_COMMON_TRANSLATIONS_PATH, {
      cache: 'no-cache',
    });

    if (!response.ok) {
      return {};
    }

    const translations = await response.json();
    return isRecord(translations) ? translations : {};
  } catch {
    return {};
  }
};

export const initializeI18n = async (): Promise<void> => {
  const publicCommonTranslations = await loadPublicCommonTranslations();

  await i18next.init({
    interpolation: { escapeValue: false },
    lng: 'en',
    ns: ['common', 'mvp', 'dentaquest', 'ahc', 'ahcadmin', 'transport'],
    fallbackNS: 'common',
    resources: {
      en: {
        common: mergeTranslationResources(
          common_en,
          publicCommonTranslations,
        ),
        mvp: mvp_en,
        dentaquest: dentaquest_en,
        ahc: ahc_en,
        ahcadmin: ahcadmin_en,
        transport: transport_en,
      },
    },
  });
};
